import { Globals } from "./globals";
/**
 * Created by Fayaz on 2/14/2018.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { Router, ActivatedRoute } from "@angular/router";
import { RestangularModule, Restangular } from "ngx-restangular";
import { AuthService } from "./auth.service";
import { API_URL } from "../config";
//************************ */
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import * as CryptoJS from "crypto-js";
import { of } from "rxjs/observable/of";
//************************ */
@Injectable()
export class AuthenticationService {
  private accessRights: any = {};
  private USER_INFO_KEY = "encrypted_user_info";
  private CACHE_EXPIRY_KEY = "user_info_expiry";
  private CACHE_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private global: Globals,
    private restangular: Restangular,
    private authService: AuthService
  ) {}

  headers: any = new HttpHeaders().set(
    "Content-Type",
    "application/x-www-form-urlencoded"
  );

  login(username: string, password: string) {
    var params: any = {
      grant_type: "password",
      client_id: "3",
      client_secret: "N1TZtXOcP0m2IJReOPsywi0xQBxiWKZKxGlRDqU1",
      username: username, //'admin@mail.com',
      password: password, //'password1',
      // 'username': "admin@pbs-int.net",
      // 'password': "welcome1",
      scope: "*",
    };
    //{ username: username, password: password }

    return this.http.post<any>(API_URL + "/oauth/token", params).map((user) => {
      // login successful if there's a jwt token in the response
      //if (user && user.token_type) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //   localStorage.setItem('currentUser', JSON.stringify(user));
      localStorage.setItem("access_token", user["access_token"]);
      localStorage.setItem("refresh_token", user["refresh_token"]);
      //sessionStorage.setItem('access_token',  user['access_token']);
      //}
      this.authService.isLoggedIn = true;
      return user;
    });
  }

  loginWithToken(username: string, token: string) {
    var params: any = {
      username: username,
      token: token,
    };

    return this.http
      .post<any>(API_URL + "api/v1/oauth/login_with_token", params)
      .map((user) => {
        localStorage.setItem("access_token", user["accessToken"]);
        localStorage.setItem("refresh_token", null);
        //sessionStorage.setItem('access_token',  user['access_token']);
        //}
        this.authService.isLoggedIn = true;
        return user;
      });
  }

  isLogged() {
    return (
      (localStorage.getItem("access_token") ||
        localStorage.getItem("refresh_token")) &&
      this.authService.isLoggedIn
    );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.clear();
    sessionStorage.clear();
    const currentUrl = this.router.url;
    if (!currentUrl.includes("pages/login")) {
      let currentRoute = currentUrl.split("?")[0];
      this.route.queryParams.subscribe((queryParams) => {
        if (Object.keys(queryParams).length != 0) {
          this.global.returnQueryParams = queryParams;
        }
      });
      this.global.returnUrl = currentRoute;
    }
    this.authService.logout();
    setTimeout(() => {
      this.router.navigate(["pages/login"]);
      const frame = document.getElementsByTagName("hds-iframe");
      if (frame.length) {
        frame[0].remove();
      }
    }, 0);
  }

  refreshToken() {
    if (localStorage.getItem("refresh_token")) {
      var params: any = {
        grant_type: "refresh_token",
        client_id: "3",
        client_secret: "N1TZtXOcP0m2IJReOPsywi0xQBxiWKZKxGlRDqU1",
        refresh_token: localStorage.getItem("refresh_token"),
        scope: "",
      };
      return this.http
        .post<any>(API_URL + "/oauth/token", params)
        .map((user) => {
          localStorage.setItem("access_token", user["access_token"]);
          localStorage.setItem("refresh_token", user["refresh_token"]);
          return user;
        });
    } else {
      this.router.navigate(["pages/login"]);
    }
  }

  checkAuth() {
    return this.restangular.one("checkUser");
  }

  checkUserGroupAccessRights() {
    return this.restangular.one("checkUserGroupAccessRights");
  }

  setUserGroupAccessRights(accessRights) {
    this.accessRights = accessRights;
  }

  getUserGroupAccessRights(currentRoute) {
    return currentRoute.data.data;
  }

  //*****************************Modify this for chaing******************************** */

  // getCurrentUserInfo() {
  //   return this.restangular.one("getCurrentUserInfo");
  // }
  getCurrentUserInfo() {
    return this.restangular.one("getCurrentUserInfo");
    /*
    // Check if cached data exists and is valid
    const cachedData = this.getCachedUserInfo();

    if (cachedData) {
      // Return Restangular-like object with get method
      return {
        get: () => Observable.of(cachedData),
      };
    }

    // If no valid cache, return Restangular one() with modified get method
    const apiCall = this.restangular.one("getCurrentUserInfo");

    return {
      get: () =>
        apiCall
          .get()
          .map((resp) => {
            // Cache the response
            this.cacheUserInfo(resp);
            return resp;
          })
          .catch((error) => {
            // Optionally log or handle the error
            console.error("Error fetching user info", error);
            return Observable.throw(error);
          }),
    };
    */
  }

  private cacheUserInfo(userInfo: any) {
    try {
      // Optional: Encrypt the data
      const encryptedData = this.encryptData(JSON.stringify(userInfo));
      localStorage.setItem("user", JSON.stringify(userInfo));
      // Store encrypted data
      localStorage.setItem(this.USER_INFO_KEY, encryptedData);

      // Store expiry timestamp
      localStorage.setItem(
        this.CACHE_EXPIRY_KEY,
        (Date.now() + this.CACHE_DURATION).toString()
      );
    } catch (error) {
      console.error("Error caching user info", error);
    }
  }

  private getCachedUserInfo() {
    try {
      const expiryTime = localStorage.getItem(this.CACHE_EXPIRY_KEY);

      // Check if cache has expired
      if (!expiryTime || parseInt(expiryTime) < Date.now()) {
        this.clearCache();
        return null;
      }

      // Retrieve and decrypt data
      const cachedData = localStorage.getItem(this.USER_INFO_KEY);
      if (!cachedData) return null;

      // Optional: Decrypt the data
      const decryptedData = this.decryptData(cachedData);
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error("Error retrieving cached user info", error);
      return null;
    }
  }

  // Optional encryption methods
  private encryptData(data: string): string {
    // Replace 'your-secret-key' with a secure key
    return CryptoJS.AES.encrypt(data, "your-secret-key").toString();
  }

  private decryptData(encryptedData: string): string {
    // Replace 'your-secret-key' with a secure key
    const bytes = CryptoJS.AES.decrypt(encryptedData, "your-secret-key");
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  private clearCache() {
    localStorage.removeItem(this.USER_INFO_KEY);
    localStorage.removeItem(this.CACHE_EXPIRY_KEY);
    localStorage.removeItem("user");
  }

  // Method to force refresh
  refreshUserInfo() {
    this.clearCache();
    return this.getCurrentUserInfo();
  }

  //***************************END */

  getTotalCountOfApproval() {
    return this.restangular.one("getTotalCountOfApproval");
  }

  loginwithToken() {
    return this.restangular.one("loginwithToken");
  }

  passwordreset() {
    return this.restangular.one("passwordreset");
  }

  forgotpassword() {
    return this.restangular.all("forgotpassword");
  }

  forgotpasswordReset() {
    return this.restangular.one("forgotpasswordReset");
  }

  getCommunicationLogPDF() {
    return this.restangular.one("getCommunicationLogPDF");
  }

  getUserMenu() {
    return this.restangular.one("getUserMenu");
  }

  checkLoggedEmployeeAzureUser() {
    return this.restangular.one("checkLoggedEmployeeAzureUser");
  }

  getTemplateAssignedRoute() {
    return this.restangular.one("getTemplateAssignedRoute");
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/authentication.service.ts